import React, { Component } from 'react';
import './edit-button.css';

class EditButton extends Component {
  render() {
    return (
      <button className="editButton" onClick={this.props.onClick}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.3335 9.77332V13.3333C13.3335 13.6869 13.193 14.0261 12.943 14.2761C12.6929 14.5262 12.3538 14.6667 12.0002 14.6667H2.66683C2.31321 14.6667 1.97407 14.5262 1.72402 14.2761C1.47397 14.0261 1.3335 13.6869 1.3335 13.3333V3.99999C1.3335 3.64637 1.47397 3.30723 1.72402 3.05718C1.97407 2.80713 2.31321 2.66666 2.66683 2.66666H6.22683" stroke="#BDBDBD" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M12.0002 1.33334L14.6668 4.00001L8.00016 10.6667H5.3335V8.00001L12.0002 1.33334Z" stroke="#BDBDBD" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

      </button>
    );
  }
}

export default EditButton;
